export default function (context, inject) {
  const config = {
  "metadatas": {
    "name": "Giphar Info",
    "webappThemeColor": "#75b72f",
    "lang": "fr-FR",
    "charset": "utf-8",
    "colorPrimary": "#75b72f",
    "colorAccent": "#ededed",
    "colorSecondary": "#ff8f00",
    "colorInfo": "#26a69a",
    "colorWarning": "#ffc107",
    "colorError": "#dd2c00",
    "colorSuccess": "#00e676",
    "iconFileName": "icon.png",
    "iconProperties": {},
    "supportEmailAddress": "contact@gipharinfo.fr",
    "siteHeadTitle": "Giphar Info",
    "appName": "Giphar Info",
    "webappFonts": {
      "google": {
        "families": [
          "Roboto:300,400,500,700",
          "Merriweather:300,400,500,700",
          "Material+Icons"
        ],
        "downloadFonts": true
      }
    }
  }
}
  const metadatas = config.metadatas

  inject('metadatas', config.metadatas)
}
